import React from 'react';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';
import qs from "qs";

const axiosInstance = Axios.create({
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const formUrlEncodedHeaders = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
};

axiosInstance.interceptors.request.use(req => {
    // 로그 남기기
    // console.log(`${JSON.stringify(req, null, 10000000)}`);
    return req;
});

axiosInstance.interceptors.response.use(
    response => {
        console.log(response.data);
        return response;
    },
    (error) => {
        console.log(error);
        const status = error?.response?.status;

        if (status === 403) {
            window.location.href = "/login.html";
        }

        if (status === 409) {
            alert(error?.response?.data?.message + '' || '409 Conflict 에러');
            window.location.reload();
        }

        if (status === 500) {
            alert('알 수 없는 에러 발생.');
        }

        return Promise.reject(error);
    }
);

axiosInstance.defaults.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
}

export default axiosInstance;